import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-device-details-network-bookings',
  templateUrl: './device-details-network-bookings.component.html',
  styleUrls: ['./device-details-network-bookings.component.scss'],
  standalone: false,
})
export class DeviceDetailsNetworkBookingsComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  deviceId: number;
  loading: boolean = true;

  ngOnInit() {
    this.activatedRoute.parent.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.deviceId = +params.deviceID;
      this.loading = false;
    });
  }
}
